import { configureStore } from '@reduxjs/toolkit';
import environmentReducer from './environmentSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'environment',
  storage,
};

const persistedEnvironmentReducer = persistReducer(persistConfig, environmentReducer);

const store = configureStore({
  reducer: {
    environment: persistedEnvironmentReducer,
  },
});

export const persistor = persistStore(store);
export default store; 